import { hashWml } from './hashWml.js';
export const filterDocumentPagesByHashes = (hashes, document) => {
    const filteredDocument = { pages: {} };
    for (const pageId in document.pages) {
        if (hashes[pageId] === undefined) {
            filteredDocument.pages[pageId] = document.pages[pageId];
        }
    }
    for (const pageId in hashes) {
        const documentPage = document.pages[pageId];
        if (documentPage) {
            const pageHash = hashWml(documentPage.data);
            if (pageHash !== hashes[pageId]) {
                filteredDocument.pages[pageId] = documentPage;
            }
        }
        else {
            filteredDocument.pages[pageId] = null;
        }
    }
    return filteredDocument;
};
